import * as React from "react";
import {cx} from "emotion";

import "./card-modal.scss";

import {cs}                      from "@Common/react/chain-services";
import {consumeContext}          from "@Common/react/context";
import {Form2}                   from "@Common/react/cs-form-2/form2";
import {scopedState}             from "@Common/react/scoped-state";
import {stateChangeNestedValue}  from "@Common/react/state-change-nested-value";
import {UseState}                from "@Common/react/use-state";
import {isDevQuan}               from "@Common/ui-components/debug/is-dev-quan";
import {DeprecatedModalService2} from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";
import {chain}                   from "@Common/utils/fs";

import {CheckboxLine} from "../../../components/checkbox-line/checkbox-line";

import {BraintreeForm} from "./braintree-form";
import {formFields}    from "./form-fields";

export const CardModal = ({next: rootNext}) => cs(

    consumeContext("apis"),
    ["modal", ({}, next) => DeprecatedModalService2({
        render: ({card, saveToProfile, forceSaveToProfile, isDefaultCard, onSave, mode, recaptchaToken}, rm) => ({
            content: next({
                recaptchaToken,
                initData: {
                    card,
                    saveToProfile,
                    isDefaultCard,
                },
                forceSaveToProfile,
                mode,
                onSave,
                close: () => rm(),
            }),
        }),
        next: rootNext,
    })],

    ["data", ({modal}, next) => UseState({
        initValue: modal.initData,
        next,
    })],
    ["addXdQaNamePrefix", ({_, modal}, next) => next((v)=> ((modal.mode === "add" ? "Add New " : "Edit ") + "Card " + v))],
    ["braintreeForm", ({addXdQaNamePrefix, modal: {recaptchaToken}}, next) => BraintreeForm({
        recaptchaToken,
        addXdQaNamePrefix,
        next,
    })],
    ["form", ({data, modal, braintreeForm}, next) => Form2({
        fields: formFields,
        data: scopedState(data, ["card"]),
        onSubmit: async () => {
            const btTokenResult = await braintreeForm.tokenize();

            await modal.onSave({
                ...data.value,
                btTokenResult,
            });

            modal.close();
        },
        next,
    })],
    ({data, modal, form, braintreeForm, addXdQaNamePrefix}) => (
        <div className="card-modal-4t5">
            <div className="title" xd-qa-type="label" xd-qa-name={(modal.mode === "add" ? "Add New " : "Edit ")+"Card"}>
                {modal.mode === "add" ? "Add new":"Edit"} Card
            </div>

            <div className="main">
                {!modal.forceSaveToProfile && CheckboxLine({
                    className: "save-to-profile",
                    label: "Save card to profile",
                    ...chain(
                        scopedState(data, ["saveToProfile"]),
                        (state) => ({
                            value: state.value,
                            onChange: (v) => data.change((d) => ({
                                ...d,
                                saveToProfile: v,
                                isDefaultCard: !v ? false : d.isDefaultCard,
                            })),
                        }),
                    ),
                    xdQaName: addXdQaNamePrefix("Save Card to Profile"),
                })}

                {braintreeForm.render({form, showErrors: form.showErrors})}

                {CheckboxLine({
                    className: "make-default",
                    label: "Make Default",
                    disabled: !data.value.saveToProfile,
                    ...scopedState(data, ["isDefaultCard"]),
                    xdQaName: addXdQaNamePrefix("Make Default"),
                })}

                {isDevQuan() && (
                    <button
                        onClick={() => stateChangeNestedValue(data, ["card"], (_) => ({
                            ..._,
                            "cardHolderName": "Test Name",
                            "streetAddress" : "Test Address",
                            "city" : "Fort Worth",
                            "state" : "TX",
                            "country" : "US",
                            zip: "11111",
                        }))}
                    >
                        Fill form
                    </button>
                )}
            </div>

            <div className="footer">
                <button
                    className="cancel"
                    onClick={() => {
                        modal.close();
                    }}
                    xd-qa-type="button"
                    xd-qa-name={addXdQaNamePrefix("Cancel")}
                >
                    Cancel
                </button>
                <button
                    className={cx("confirm", {disabled: !braintreeForm.isValid() || !form.valid})}
                    onClick={form.submit}
                    xd-qa-type="button"
                    xd-qa-name={addXdQaNamePrefix((modal.mode === "add" ? "Add " : "Update ") + "Card")}
                >
                    {modal.mode === "add" ? "Add":"Update"} Card
                </button>
            </div>
        </div>
    ),
);
